module.exports = __webpack_public_path__ + "static/media/TrainingAndConsoltancy.4c26494d.png";